import script from "./ProfileMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileMenu.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileMenu.vue?vue&type=style&index=0&id=4ce17cdf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ce17cdf"]])

export default __exports__